<template>
  <main class="custom">
    <div class="col pos-s mar-b">
      <div class="sticky">
        <h2>CUSTOM</h2>
        <div class="txt" v-html="custom.description" />
      </div>
    </div>
    <div class="col pos-s mar-b">
      <div class="sticky">
        <h2 class="bdb">Orderform</h2>
        <form v-if="!sent && !loading && !error">
          <input
            type="text"
            name="name"
            v-model="name"
            placeholder="First name, Last name*"
          />
          <input
            type="text"
            name="email"
            v-model="email"
            placeholder="Email*"
          />
          <input
            type="text"
            name="phone"
            v-model="phone"
            placeholder="Phone number"
          />

          <input
            type="text"
            name="address"
            v-model="address"
            placeholder="Address*"
          />
          <input
            type="text"
            name="post"
            v-model="post"
            placeholder="Postal code*"
          />
          <input type="text" name="city" v-model="city" placeholder="City*" />
          <input
            type="text"
            name="country"
            v-model="country"
            placeholder="Country*"
          />
          <input
            type="text"
            name="dimensions"
            v-model="dimensions"
            placeholder="Dimensions*"
          />
          <input
            type="text"
            name="colors"
            v-model="colors"
            placeholder="Colors*"
          />
          <textarea
            name="comments"
            v-model="comments"
            rows="6"
            cols="80"
            resize="none"
            placeholder="Questions and comments"
          ></textarea>
          <div class="check-container" @click="terms = !terms">
            <span id="checkmark" :class="{ active: terms }"></span>
            I hereby agree to the terms and conditions*
          </div>
          <input
            type="submit"
            name="submit"
            @click.prevent="sendEmail"
            value="Send request"
            :disabled="!valid"
          />
        </form>
        <div class="btb" v-if="loading">
          Sending...
        </div>
        <div class="btb" v-if="error">
          An error occured please refresh and try again.
        </div>
        <div class="btb" v-if="sent">
          Thank you for your order! I will get in touch with you soon.
        </div>
      </div>
    </div>
    <div class="col">
      <h2>TERMS AND CONDITIONS</h2>
      <div class="txt" v-html="custom.terms" />
    </div>
  </main>
</template>

<script>
import axios from "axios";
export default {
  name: "custom",
  computed: {
    custom() {
      return this.$store.state.custom;
    },
    valid() {
      if (
        this.name.length > 0 &&
        this.email.length > 0 &&
        this.address.length > 0 &&
        this.post.length > 0 &&
        this.city.length > 0 &&
        this.country.length > 0 &&
        this.dimensions.length > 0 &&
        this.colors.length > 0 &&
        this.terms
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  data() {
    return {
      error: false,
      loading: false,
      sent: false,
      name: "",
      email: "",
      phone: "",
      address: "",
      post: "",
      city: "",
      country: "",
      dimensions: "",
      colors: "",
      comments: "",
      terms: false
    };
  },
  metaInfo() {
    return {
      title: "– Custom"
    };
  },
  methods: {
    sendEmail() {
      // console.log("sending email");
      this.loading = true;
      axios
        .post(
          "/api/sendmail/",
          {
            email: this.email,
            name: this.name,
            phone: this.phone,
            address: this.address,
            post: this.post,
            city: this.city,
            country: this.country,
            dimensions: this.dimensions,
            colors: this.colors,
            message: this.comments
          },
          {
            auth: {
              username: process.env.VUE_APP_USERNAME,
              password: process.env.VUE_APP_PASSWORD
            }
          }
        )
        .then(() => {
          // console.log(res);
          this.loading = false;
          this.sent = true;
          this.error = false;
        })
        .catch(() => {
          // console.log(err);
          this.loading = false;
          this.sent = false;
          this.error = true;
        });
    }
  }
};
</script>

<style lang="scss">
.custom {
  .sticky {
    position: sticky;
    top: 5em;
    @media only screen and (max-width: 768px) {
      position: relative;
      top: auto;
    }
  }
  .mar-b {
    margin-bottom: 1em;
  }
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1em;
  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
  p {
    letter-spacing: 0.1em !important;
  }
  ol {
    list-style: decimal;
    padding-left: 1.5em !important;
    li {
      list-style: inherit !important;
    }
  }
  .bdb {
    padding-bottom: 0.5em;
    border-bottom: 1px dashed black;
  }
  .btb {
    padding: 0.5em 0;
    border-bottom: 1px dashed black;
  }
  input,
  textarea {
    width: 100%;
    appearance: none;
    padding: 0.5em 0;
    border: 0;
    border-bottom: 1px dashed black;
    background: transparent;
    outline: none;
    border-radius: none;
    font-family: "Walter";
    letter-spacing: 0.1em;
    font-size: 14.4px;
    @media only screen and (max-width: 768px) {
      font-size: 12.8px;
    }
    line-height: 1;
    display: block;
    resize: none;
    &::placeholder {
      color: black;
      text-transform: uppercase;
      letter-spacing: 0.3em;
    }
    &[type="checkbox"] {
      width: auto;
      border-radius: 50%;
    }
    &[type="submit"] {
      border: 1px dashed black;
      margin-top: 1em;
      width: auto;
      cursor: pointer;
      border-radius: 12px;
      padding: 0.5em 0.8em 0.4em;
      text-transform: uppercase;
      letter-spacing: 0.3em;
      &:disabled {
        color: grey;
        border-color: grey;
      }
    }
  }
  .check-container {
    display: flex;
    padding: 0.5em 0;
    border-bottom: 1px dashed black;
    &:hover {
      cursor: pointer;
      #checkmark {
        background: grey;
        &.active {
          background: grey;
        }
      }
    }
    #checkmark {
      flex: 0 0 11px;
      display: inline-block;
      margin-right: 0.5em;
      margin-top: 3px;
      height: 11px;
      background: transparent;
      border-radius: 50%;
      transition: background 0.5s;
      border: 1px dotted black;
      &.active {
        background: black;
      }
    }
  }

  .col {
    grid-column: span 1;
    .item {
      display: flex;
      .year {
        flex: 0 0 auto;
        padding-right: 1em;
        font-feature-settings: "tnum";
      }
      .title {
        flex: 1 1 auto;
      }
    }
    .txt {
      text-transform: none;
      letter-spacing: 0.1em;
      padding-right: 0.5em;
      h2 {
        letter-spacing: 0.3em;
      }
      p {
        margin-bottom: 1em !important;
      }
      a {
        transition: letter-spacing 0.2s;
        &:hover {
          letter-spacing: 0.4em;
        }
      }
    }
  }
}
</style>
